import React from "react";
import PropTypes from "prop-types";

import { ClickAwayListener } from "@material-ui/core";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import styles from "./styles";

import imageAppSaludsaMegaMenu from "../../../assets/images/app-saludsa-mobile-saludsa.png";
import imageAppExperienceMegaMenu from "../../../assets/images/app-experience-mobile-saludsa.png";
import imageProfileMegaMenu from "../../../assets/images/image_profile1.png";
import imageChatMegaMenu from "../../../assets/images/cs_chat_mega_menu.png";
import imageContactMegaMenu from "../../../assets/images/cs_contact_center_mega_menu.png";
import imageServicesFooterMegaMenu from "../../../assets/images/fondo_servicios.png";

export const MenuServices = ({ handleClickAway, visible }) => {
  const classes = styles();
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div
        className={classes.absoluteSContainer}
        style={{ display: visible ? "flex" : "none" }}
      >
        <div className={classes.coberturaEcuadorMegaMenu}>
          <div className={classes.megaMenuMedicMundial}>
            <div style={{ maxWidth: "225px", marginRight: "25px" }}>
              <div className={classes.tituloContenedorCoberturaMegaMenu}>
                Nuestros canales
              </div>
              <div className={classes.subtituloContenedorCoberturaMegaMenu}>
                Ofrecerte una experiencia de servicio única es nuestra
                prioridad. Ponemos a tu disposición canales de atención de
                avanzada, selecciona el canal de atención tu preferencia.
              </div>
            </div>
            <div style={{ height: "100%" }}>
              <div className={classes.tituloCanalesServiciosMegaMenu}>
                Nuestras Apps
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ marginRight: "10px" }}>
                  <img
                    src={imageAppSaludsaMegaMenu}
                    alt="app_saudsa_menu"
                    style={{ marginBottom: "6px" }}
                  />
                  <div>
                    <a
                      href="http://onelink.to/ag439w"
                      className={classes.descripcionTarjetaAsistenciaMedica}
                    >
                      AppSaludsa
                    </a>
                  </div>
                </div>
                <div>
                  <img
                    src={imageAppExperienceMegaMenu}
                    alt="app_experience_menu"
                    style={{ marginBottom: "6px", marginLeft: "6px" }}
                  />
                  <div>
                    <a
                      href="http://onelink.to/4bd4c4"
                      className={classes.descripcionTarjetaAsistenciaMedica}
                    >
                      AppExperience
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className={classes.lineaDivisorCanalesServicios}></div>

            <div style={{ height: "100%" }}>
              <div
                className={classes.tituloCanalesServiciosMegaMenu}
                style={{ marginBottom: "30px" }}
              >
                saludsa.com
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <img
                    src={imageProfileMegaMenu}
                    alt="saludsa_informacion"
                    className={classes.imageCsMegaMenu}
                  />
                  <a
                    href="https://www.videoask.com/f1u1aaeh4"
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div className={classes.descripcionTarjetaAsistenciaMedica}>
                      Oficina virtual
                    </div>
                    <span
                      className={`${classes.arrowIcon} ${classes.colorlightBlue}`}
                    >
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href="https://www.saludsapersonas.com/portalclientes/Account/Login"
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div className={classes.descripcionTarjetaAsistenciaMedica}>
                      Portal de clientes
                    </div>
                    <span
                      className={`${classes.arrowIcon} ${classes.colorlightBlue}`}
                    >
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                </div>
              </div>
            </div>

            <div className={classes.lineaDivisorCanalesServicios}></div>

            <div style={{ height: "100%" }}>
              <div
                className={classes.tituloCanalesServiciosMegaMenu}
                style={{ marginBottom: "30px" }}
              >
                Chat de atención
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <img
                    src={imageChatMegaMenu}
                    alt="chat_mega_menu"
                    style={{ marginBottom: "37px" }}
                  />
                  <a
                    href="https://servicios.saludsa.com.ec/ChatGenesis/informacion.html?x=76&y=10"
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div className={classes.descripcionTarjetaAsistenciaMedica}>
                      Iniciar chat en línea
                    </div>
                    <span
                      className={`${classes.arrowIcon} ${classes.colorlightBlue}`}
                    >
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href="https://api.whatsapp.com/send?phone=+593989404239&text=Hola,%20soy%20cliente%20de%20Saludsa,%20necesito%20servicio%20al%20cliente."
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div className={classes.descripcionTarjetaAsistenciaMedica}>
                      Iniciar WhatsApp
                    </div>
                    <span
                      className={`${classes.arrowIcon} ${classes.colorlightBlue}`}
                    >
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                </div>
              </div>
            </div>

            <div className={classes.lineaDivisorCanalesServicios}></div>

            <div style={{ height: "100%" }}>
              <div
                className={classes.tituloCanalesServiciosMegaMenu}
                style={{ marginBottom: "30px" }}
              >
                Contact center
              </div>
              <div style={{ display: "flex" }}>
                <div>
                  <img
                    src={imageContactMegaMenu}
                    alt="contact_mega_menu"
                    style={{ marginBottom: "25px" }}
                  />
                  <a
                    href="tel: 026020920"
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div className={classes.descripcionTarjetaAsistenciaMedica}>
                      Sierra: 026020920
                    </div>
                    <span
                      className={`${classes.arrowIcon} ${classes.colorlightBlue}`}
                    >
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                  <a
                    href="tel: 046020920"
                    className={classes.linkPageCoberturaMegaMenu}
                  >
                    <div className={classes.descripcionTarjetaAsistenciaMedica}>
                      Costa: 046020920
                    </div>
                    <span
                      className={`${classes.arrowIcon} ${classes.colorlightBlue}`}
                    >
                      <ArrowForwardIosIcon className={classes.iconSize} />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className={classes.megaMenuMedicMundial} style={{ padding: 0 }}>
            <div
              className={classes.coberturaEcuadorMegaMenu}
              style={{
                backgroundImage: `url(${imageServicesFooterMegaMenu})`,
                minHeight: "85px",
                borderBottomRightRadius: "7px",
                borderBottomLeftRadius: "7px",
                padding: "28px 35px",
                backgroundColor: "#745296",
                backgroundRepeat: "none",
                alignItems: "center",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <div
                className={classes.tituloContenedorCoberturaMegaMenu}
                style={{
                  color: "#ffffff",
                  textShadow: "none",
                  width: "225px",
                  marginBottom: 0
                }}
              >
                Nuestros servicios
              </div>
              <div
                className={classes.subtituloContenedorCoberturaMegaMenu}
                style={{ color: "#ffffff", maxWidth: 310, marginTop: 0 }}
              >
                Ponemos a tu disposición nuestros servicios, para mejorar tu
                experiencia.
              </div>
              <div>
                <a
                  href="/reembolso-online/"
                  className={classes.botonesCoberturaFrenteCancerMegaMenu}
                >
                  Reembolso Online
                </a>
              </div>

              <div>
                <a
                  href="https://apps.saludsa.com/saludsapay/?__hstc=213659531.f1a25314a93e8960690d4f87c24f8f56.1620657222726.1620672653676.1620677609649.5&__hssc=213659531.1.1620677609649&__hsfp=3955714536"
                  className={classes.botonesCoberturaFrenteCancerMegaMenu}
                >
                  Saludsa Pay
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ClickAwayListener>
  );
};

MenuServices.propTypes = {
  handleClickAway: PropTypes.any,
  visible: PropTypes.any
};
